export const HISTORICAL_LOAD = "HISTORICAL_LOAD";
export const HISTORICAL_REFRESH = "HISTORICAL_REFRESH";
export const HISTORICAL_LOAD_REQUESTING = "HISTORICAL_LOAD_REQUESTING";
export const HISTORICAL_REFRESH_REQUESTING = "HISTORICAL_REFRESH_REQUESTING";
export const HISTORICAL_ERROR = "HISTORICAL_ERROR";
export const HISTORICAL_MODIFY = "HISTORICAL_MODIFY";
export const HISTORICAL_ADD_LOVE = "HISTORICAL_ADD_LOVE";
export const EVENT_CREATE = "EVENT_CREATE";
export const HISTORICAL_UNSET = "HISTORICAL_UNSET";
export const HISTORICAL_VISIBLE = "HISTORICAL_VISIBLE";
export const HISTORICAL_SELECT = "HISTORICAL_SELECT";

export const SELECT_FEEDBACK = "historical/SELECT_FEEDBACK";
